module.exports = __webpack_public_path__ + "img/img17.09b0b9d1.png";